import { render, staticRenderFns } from "./SezioneValutazione.vue?vue&type=template&id=cdd9ee3c&scoped=true"
import script from "./SezioneValutazione.vue?vue&type=script&lang=js"
export * from "./SezioneValutazione.vue?vue&type=script&lang=js"
import style0 from "./SezioneValutazione.vue?vue&type=style&index=0&id=cdd9ee3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd9ee3c",
  null
  
)

export default component.exports